import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, TemplateRef } from '@angular/core';
import { ChangeDetector } from '../../change-detector';

@Component({
  template: `<ng-container [ngTemplateOutlet]="template"></ng-container>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateComponent extends ChangeDetector {
  @Input() template: TemplateRef<any>;

  detectChanges() {
    this.$detectChanges();
  }

  constructor(@Inject(DOCUMENT) document: any, cd: ChangeDetectorRef) {
    super((document as Document).defaultView, cd);
  }
}
